/**
 * https://yandex.ru/support/metrica/ecommerce/data.html
 */

import {eventBus} from "./event-bus-store.js";
import {menuStore, publishConfigStore} from "./app-store.js";

let restaurantName;
let menuName;
let menu;
let currencyCode = 'RUB';
let ymId;

menuStore.subscribe(x => {
    menu = x;
    menuName = x.name;
});
publishConfigStore.subscribe(x => {
    restaurantName = x.restaurantName;
    currencyCode = x.currencyCode;
    ymId = x.ymId;

    if (!currencyCode && x.currency) {
        switch (x.currency){
            case '₽': currencyCode = 'RUB'; break;
            case 'руб': currencyCode = 'RUB'; break;
            case 'р': currencyCode = 'RUB'; break;
            case 'Br': currencyCode = 'BYN'; break;
            case 'BYN': currencyCode = 'BYN'; break;
            case '₸': currencyCode = 'KZT'; break;
            case 'тг': currencyCode = 'KZT'; break;
            case '₴': currencyCode = 'UAH'; break;
            case '₼': currencyCode = 'AZN'; break;
            case '֏': currencyCode = 'AMD'; break;
            case '₾': currencyCode = 'GEL'; break;
            case 'сом': currencyCode = 'KGS'; break;
            case 'soʻm': currencyCode = 'UZS'; break;
            case '₺': currencyCode = 'TRY'; break;
            case '€': currencyCode = 'EUR'; break;
            case '$': currencyCode = 'USD'; break;
            case '£': currencyCode = 'GBP'; break;
            default:
                currencyCode = 'RUB';
        }
    }
})

eventBus.subscribe(events => {

    try {
        for (let i = 0; i < events.length; i++) {

            const e = events[i];

            if (e.event === 'openDetails' && e.payload?.record?.id != null) {
                const id = e.payload.record.id;
                const {found, sectionName, position, productName, price} = searchMenuItemById(id, e.payload.priceIndex);
                if (found) {
                    reportOpenDetails(currencyCode, id, productName, price, restaurantName, sectionName, '', menuName, position)
                }
            }

            if ((e.event === 'addToCart' || e.event === 'incrementItemInCart') && e.payload?.record?.id != null) {

                const id = e.payload.record.id;
                const {found, sectionName, position, productName, price, discount} = searchMenuItemById(id, e.payload.priceIndex);
                if (found) {
                    reportAddToCart(currencyCode, id, productName, price, discount, restaurantName, sectionName, 1, menuName, position);
                }
            }

            if ((e.event === 'removeFromCart' || e.event === 'decrementItemInCart') && e.payload?.record?.id != null) {

                const id = e.payload.record.id;
                const {found, sectionName, position, productName} = searchMenuItemById(id, e.payload.priceIndex);
                if (found) {
                    reportRemoveFromCart(currencyCode, id, productName, sectionName, 1, menuName, position);
                }
            }

            if (e.event === 'purchase' && e.payload != null) {

                const {items, revenue, orderNumber} = e.payload;

                if (!items || items.length === 0 || !revenue) {
                    return;
                }

                const products = [];

                (menu.sections || []).forEach(section => {
                    (section.records || []).forEach((record, idx) => {
                        const inCart = (items || []).find(x => x?.id === record?.id)
                        if (inCart) {
                            products.push({
                                id: inCart.id,
                                name: inCart.name,
                                price: inCart.price,
                                quantity: inCart.count,
                                // brand: '',
                                list: menu.name,
                                category: section.title,
                                position: idx
                            });
                        }
                    });
                });

                reportPurchase(currencyCode, orderNumber, revenue, products);
            }
        }
    }
    catch (e) {
        console.error(e);
    }
});

const searchMenuItemById = (id, priceIndex) => {

    let found = false;

    let sectionName, position, productName, price, discount;

    (menu.sections || []).forEach(section => {
        (section.records || []).forEach((record, idx) => {
            if (record.id === id && found === false) {
                found = true;

                sectionName = section.title;
                position = idx;
                productName = record.name;
                price = record.prices[priceIndex || 0].price;
                discount = (record.prices[priceIndex || 0].oldPrice || price) - price;
            }
        });
    });

    return {
        found, sectionName, position, productName, price, discount
    };
}


export const reportOpenListOfProducts = (currencyCode, products) => {

    try {

        if (!window.dataLayer) {
            return;
        }

        window.dataLayer.push({
            ecommerce: {
                currencyCode: currencyCode || "RUB",
                impressions: products.map(x => {

                    return {
                        id: x.id,
                        name: x.name,
                        price: x.price,
                        brand: x.brand,
                        category: x.category,
                        variant: x.variant,
                        list: x.list,
                        position: x.position
                    };

                }).filter(x => x.id !== null || x.name !== null)
            }
        });

    }
    catch (e) {
        console.error(e);
    }
}

/**
 *
 * @param currencyCode
 * @param id
 * @param name - productName
 * @param price
 * @param brand - restaurantName
 * @param category - sectionName
 * @param variant
 * @param list - menu name
 * @param position
 */
export const reportClickOnProduct = (currencyCode, id, name, price, brand, category, variant, list, position) => {

    try {

        if (!window.dataLayer) {
            return;
        }

        window.dataLayer.push({
            ecommerce: {
                currencyCode: currencyCode || "RUB",
                click: {
                    products: [{id, name, price, brand, category, variant, list, position}]
                }
            }
        });

    }
    catch (e) {
        console.error(e);
    }
}

/**
 *
 * @param currencyCode
 * @param id
 * @param name - productName
 * @param price
 * @param brand - restaurantName
 * @param category - sectionName
 * @param variant
 * @param list - menu name
 * @param position
 */
export const reportOpenDetails = (currencyCode, id, name, price, brand, category, variant, list, position) => {

    try {


        if (!window.dataLayer) {
            console.log('[reportOpenDetails] dataLayer disabled');
            return;
        }

        window.dataLayer.push({
            ecommerce: {
                currencyCode: currencyCode || "RUB",
                detail: {
                    products: [{id, name, price, brand, category, variant, list, position}]
                }
            }
        });

        console.log('[detail]', {currencyCode, id, name, price, brand, category, variant, list, position});

    }
    catch (e) {
        console.error(e);
    }
}

/**
 *
 * @param currencyCode
 * @param id
 * @param name - productName
 * @param price
 * @param discount - (discount || price) - price
 * @param brand - restaurantName
 * @param category - sectionName
 * @param quantity
 * @param list - menu name
 * @param position
 */
export const reportAddToCart = (currencyCode, id, name, price, discount, brand, category, quantity, list, position) => {

    try {
        if (!window.dataLayer) {
            console.log('[reportAddToCart] dataLayer disabled');
            return;
        }

        window.dataLayer.push({
            ecommerce: {
                currencyCode: currencyCode || "RUB",
                add: {
                    products: [{id, name, price, brand, category, quantity, list, position}]
                }
            }
        });

        console.log('[add]', {currencyCode, id, name, price, discount, brand, category, quantity, list, position});
    }
    catch (e) {
        console.error(e);
    }
}

/**
 *
 * @param currencyCode
 * @param id
 * @param name
 * @param category - sectionName
 * @param quantity
 * @param list - menu name
 * @param position
 */
export const reportRemoveFromCart = (currencyCode, id, name, category, quantity, list, position) => {

    try {

        if (!window.dataLayer) {
            console.log('[reportRemoveFromCart] dataLayer disabled');
            return;
        }

        window.dataLayer.push({
            ecommerce: {
                currencyCode: currencyCode || "RUB",
                remove: {
                    products: [{id, name, category, quantity, list, position}]
                }
            }
        });

        console.log('[remove]', {currencyCode, id, name, category, quantity, list, position});
    }
    catch (e) {
        console.error(e);
    }
}

/**
 *
 * @param currencyCode
 * @param orderNumber
 * @param revenue
 * @param products: {id, name, price, category, quantity, list, position}
 *
 * id
 * name
 * category - sectionName
 * quantity
 * list - menu name
 * position
 * */
export const reportPurchase = (currencyCode, orderNumber, revenue, products) => {

    try {

        if (!window.dataLayer) {
            return;
        }

        window.dataLayer.push({
            ecommerce: {
                currencyCode: currencyCode || "RUB",
                actionField: {
                    id: orderNumber,
                    revenue: revenue
                },
                purchase: {
                    products: products || []
                }
            }
        });

        console.log('[reportPurchase]', {currencyCode, orderNumber, revenue});
    }
    catch (e) {
        console.error(e);
    }
}

export const reachGoal = (goal) => {

    try {
        if (!window.ym || !ymId || !goal) {
            console.log('[reachGoal] disabled');
            return;
        }

        window.ym(ymId, 'reachGoal', goal);
    }
    catch (e) {
        console.error(e);
    }
}
